
import topbar from './topbar';
import ast from './ast';

const astPlugin = {
  install(Vue) {
    Vue.prototype.$astTgclubPlugin = {
      // ==============入口模块===================
      entryPoint: topbar.initTgclubTopbar, // 初始化头部下载导航
      // ==============APP模块================
      isAPP: ast.isAPP,
      gotoAPP: ast.gotoAPP,
      setAPPShare: ast.setAPPShare,
      goAPPShare: ast.goAPPShare,
      disableAPPShare: ast.disableAPPShare,
      openView: ast.openView,
      getPlatform: ast.getPlatform,
      initAPPShare: ast.initAPPShare,
      callGame: ast.callAndDownLoadGame,
      getFlowRequestExtData: ast.getFlowRequestExtData,
      getAstConfig: ast.getAstConfig,
    };
  },
};
export default astPlugin;
